import React, { FC } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { LoadingError, PageHeader, UserStateComponent } from '../../../components';
import { DeviceListItem } from '../../../components/Device';
import { useTranslation } from '../../../translations';
import { Fetcher, useConvention, useFetcher, useUserSafe } from '../../../utils';
import { AuthorizeDevice } from './authorize';

export const DevicesPage: FC = () => {
  const user = useUserSafe();
  const { ts } = useTranslation();
  const convention = useConvention();

  const fetcher = useFetcher(async () => {
    if (convention.disableQuikTicket) {
      return undefined;
    }

    return await api.getUserDeviceList(user.id);
  }, [user.id, convention.disableQuikTicket]);

  if (convention.disableQuikTicket) {
    return (
      <>
        <PageHeader>{ts('common.devices')}</PageHeader>
        <LoadingError errorText={ts('device_authorization_disabled')} />
      </>
    );
  }

  return (
    <>
      <PageHeader>{ts('common.devices')}</PageHeader>
      <UserStateComponent>
        {fetcher.data ? (
          <Row>
            <Col lg={8} xs={12}>
              {fetcher.data.map((device) => (
                <DeviceListItem device={device} key={device.id} />
              ))}
            </Col>
            <Col lg={4} xs={12}>
              <Card>
                <CardBody>
                  <h4>{ts('authorize_new_device')}</h4>
                  <p>
                    <small>{ts('to_authorize_a_new_device')}</small>
                  </p>
                  <p>
                    <small>{ts('devices_are_authorized_for_6_hours_before')}</small>
                  </p>
                  <hr />
                  <AuthorizeDevice />
                </CardBody>
              </Card>
            </Col>
          </Row>
        ) : (
          <Fetcher inline result={fetcher} />
        )}
      </UserStateComponent>
    </>
  );
};
